import React from 'react';
import './PrivateLobbyOverlay.css';
import {sendButtonClickEvent} from '../../analytics/gameAnalytics';

const PAGE_ID = 'PrivateLobbyOverlay';

function PrivateLobbyOverlay({onShop, onBack}) {
  // Кнопки своего вида, не PageButton (тот навесил бы стиль кнопок меню), —
  // клики отмечаются вручную: page:PrivateLobbyOverlay:button:shop | back
  const handleShop = () => {
    sendButtonClickEvent(PAGE_ID, 'shop');
    onShop?.();
  };
  const handleBack = () => {
    sendButtonClickEvent(PAGE_ID, 'back');
    onBack?.();
  };

  return (
    <div className="private-lobby-overlay">
      <h2 className="private-lobby-overlay-title">
        <img
          className="private-lobby-overlay-icon"
          src="/img/icons/lock_grey.png"
          alt=""
          title="Приватное лобби"
        />
        Приватное лобби
      </h2>
      <p className="private-lobby-overlay-text">
        Присоединиться к этой игре или наблюдать за ней могут только приглашённые
        участники. Создавать приватные лобби, недоступные для зрителей, могут
        только игроки с премиум-аккаунтом.
      </p>
      <div className="private-lobby-overlay-buttons">
        <button className="private-lobby-overlay-button private-lobby-overlay-button_shop" onClick={handleShop}>
          В магазин
        </button>
        <button className="private-lobby-overlay-button" onClick={handleBack}>
          Назад
        </button>
      </div>
    </div>
  );
}

export default PrivateLobbyOverlay;
